import React, { useCallback, useEffect, useState } from 'react'
import { redirect, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { PuffLoader, PulseLoader } from 'react-spinners'
import { CustomerRestaurantOrderDetailApi } from '../redux/actions/Order/CustomerRestaurantOrderDetailAction';
import { useDispatch, useSelector } from 'react-redux';
import { SupplierDetailApi } from '../redux/actions/User/Detail/SupplierDetailAction';
import backend_url from '../services/endpoints';
import { formatDate, formatTime12Hour } from '../helpers/formatDateTime';
import { ChangeOrderStatusAPI } from '../redux/actions/User/Detail/ChangeOrderStatusAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { changeOrderStatusStateReset } from '../redux/slices/User/Detail/ChangeOrderStatusSlice';
import StripePaymentComponent from '../components/Stripe/StripePaymentComponent';
import { PaymentElement } from '@stripe/react-stripe-js';

const OrderDetail = () => {

    const { role, id } = useParams();
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const redirectStatus = searchParams.get('redirect_status');
    const paymentIntent = searchParams.get('payment_intent');

    const { response: orderDetailResponse, error: orderDetailError, loading: orderDetailLoading } = useSelector((state) => state.customer_restaurant_order_detail)
    const { response: changeOrderStatusResponse, error: changeOrderStatusError, loading: changeOrderStatusLoading } = useSelector((state) => state.changeOrderStatus);


    console.log(orderDetailResponse?.data?.deliveryCharges, "jkdhvfkjvhsvkjhn")

    // const [page, setPage] = useState(1);
    // const [limit, setLimit] = useState(5);
    // const [type, setType] = useState(1);

    const [acceptButtonClicked, setAcceptButtonClicked] = useState(false);
    const [rejectButtonClicked, setRejectButtonClicked] = useState(false);

    const [acceptRequestLoading, setAcceptRequestLoading] = useState(false);
    const [rejectRequestLoading, setRejectRequestLoading] = useState(false);

    const [showPaymentTypePopup, setShowPaymentTypePopup] = useState(false);

    const [showDateTimeFields, setShowDateTimeFields] = useState(false);
    const [completePayment, setCompletePayment] = useState(false);
    const [showStripeForm, setShowStripeForm] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [validationErrors, setValidationErrors] = useState({ date: false, time: false });
    const [remarks, setRemarks] = useState('');
    const [hasCompleted, setHasCompleted] = useState(false);

    const [showInput, setShowInput] = useState(false);
    const [deliveryCharges, setDeliveryCharges] = useState('');
    const [finalDeliveryCharges, setFinalDeliveryCharges] = useState(orderDetailResponse?.data?.deliveryCharges ?? 0);

    const [paymentType, setPaymentType] = useState('');
    const fetchOrderDetail = useCallback(() => {
        dispatch(CustomerRestaurantOrderDetailApi(id));
    }, [dispatch, id, role]);

    const handleClick = () => {
        setShowInput(true);
    };

    const handleChange = (e) => {
        setDeliveryCharges(e.target.value);
    };

    const handleBlur = () => {
        if (deliveryCharges !== '') {
            setFinalDeliveryCharges(Number(deliveryCharges)); // ✅ Use local state
        }
        setShowInput(false);
    };

    const getOrderStatus = (t) => {
        if (t == 0 || t == 7) {
            return 'Pending'
        }
        else if (t == 1) {
            return 'Accepted'
        }
        else if (t == 2) {
            return 'Rejected'
        }
        else if (t == 3) {
            return 'Cancelled'
        }
        else if (t == 4) {
            return 'Payment Pending'
        }
        else if (t == 5) {
            return 'Completed'
        }
        else if (t == 6) {
            return 'Reported'
        }
    }

    const validateForm = () => {
        const newErrors = {};

        if (!remarks) newErrors.remarks = true;
        if (!paymentType) newErrors.paymentType = true;

        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };

    const handleRejectOrderRequest = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status,

            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in reject order request', error)
        }
    }

    const handleAcceptOrderRequest = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status,
                scheduledDate: selectedDate,
                scheduledTime: selectedTime,
                deliveryCharges: finalDeliveryCharges
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in accept order request', error)
        }
    }

    const handleSubmit = async (orderId, status) => {
        if (!validateForm()) {
            return;
        }
        try {
            const data = {
                orderId: orderId,
                status: status,
                paymentType: paymentType,
                remark: remarks
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in add payment order request', error)
        }
    }

    const handleSubmitComplete = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status,
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in complete order request', error)
        }
    }

    // if (redirectStatus === 'succeeded') {
    //     console.log("✅ Payment succeeded with intent:", paymentIntent);
    //     onPaymentSuccess?.(); // Call your handler or update order
    //     setCompletePayment(true);
    // } else if (redirectStatus === 'failed') {
    //     console.error("❌ Payment failed");
    // }
    useEffect(() => {
        fetchOrderDetail();
    }, []);

    useEffect(() => {
        if (acceptButtonClicked && changeOrderStatusLoading) {
            setAcceptRequestLoading(prev => !prev);
        }
    }, [changeOrderStatusLoading, acceptButtonClicked])

    useEffect(() => {
        if (rejectButtonClicked && changeOrderStatusLoading) {
            setRejectRequestLoading(prev => !prev);
        }
    }, [changeOrderStatusLoading, rejectButtonClicked])

    useEffect(() => {
        if (changeOrderStatusResponse?.status === true) {
            showSuccessToast(changeOrderStatusResponse?.message);
            dispatch(changeOrderStatusStateReset());
            setPaymentType('');
            setRemarks('');
            fetchOrderDetail();
        }
    }, [changeOrderStatusResponse])

    useEffect(() => {
        if (changeOrderStatusError) {
            showErrorToast(changeOrderStatusError?.data || "Something went wrong");
            dispatch(changeOrderStatusStateReset());
        }
    }, [changeOrderStatusError])

    useEffect(() => {
        if (orderDetailResponse?.status === true) {
            setDeliveryCharges('');
            setFinalDeliveryCharges('');
        }
    }, [orderDetailResponse])

    useEffect(() => {
        if (!hasCompleted && redirectStatus && paymentIntent && orderDetailResponse?.data?._id) {
            handleSubmitComplete(orderDetailResponse?.data?._id, 5);
            setHasCompleted(true);
            // window.history.replaceState(null, '', `/admin-dashboard/order-detail/supplier/${orderDetailResponse?.data?._id}`);
            navigate(`/admin-dashboard/order-detail/supplier/${orderDetailResponse?.data?._id}`);

            // fetchOrderDetail()
        }
    }, [redirectStatus, paymentIntent, orderDetailResponse, hasCompleted])

    return (
        <>
            {orderDetailLoading ? (
                <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center text-center'>
                    <PulseLoader size={85} color="#0f0a30" />
                </div>
            ) :
                orderDetailError ? (
                    <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
                        <p className='text-danger'>Something went wrong</p>
                    </div>) : (
                    <section className='main'>
                        <div className='container'>
                            <div className='row gy-4'>
                                <div className='col-12'>
                                    <div className="wrapper-card">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className='hstack flex-wrap gap-3'>
                                                    <div className='supp_img'>
                                                        <img src={orderDetailResponse?.data?.userImage ? `${backend_url}${orderDetailResponse?.data?.userImage}` : '/assets/images/user.png'} alt="Supplier" />
                                                    </div>
                                                    <div className="info_content">
                                                        <div className='supplier_name_blk mb-3'>
                                                            <h3 className='fw-bold mb-0'>{orderDetailResponse?.data?.userFirstName}</h3>
                                                        </div>
                                                        <div className="info_content-row hstack flex-wrap">
                                                            <div className="info-detail">
                                                                <h2 className="h4">Location</h2>
                                                                <p className="mb-0">
                                                                    {[
                                                                        orderDetailResponse?.data?.street,
                                                                        orderDetailResponse?.data?.city,
                                                                        orderDetailResponse?.data?.state,
                                                                        orderDetailResponse?.data?.country
                                                                    ]
                                                                        .filter(Boolean)  // removes undefined, null, empty string
                                                                        .join(", ")}
                                                                </p>
                                                            </div>
                                                            <div className="info-detail">
                                                                <h2 className="h4">Contact Number</h2>
                                                                <p className="mb-0">{orderDetailResponse?.data?.phoneNumber}</p>
                                                            </div>
                                                            <div className="info-detail">
                                                                <h2 className="h4">Email Address</h2>
                                                                <p className="mb-0">{orderDetailResponse?.data?.email}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row gy-4 mt-3'>
                                <div className='col-12'>
                                    <div className='wrapper-card'>
                                        <div className='row gy-4'>
                                            <div className='col-md-5'>
                                                <div className='status_card_wrapper hstack flex-wrap gap-4'>
                                                    {Array.isArray(orderDetailResponse?.data?.requestedProducts) && orderDetailResponse?.data?.requestedProducts?.map((c, index) => {
                                                        return (

                                                            <div className='inner_outline_card hstack align-items-start m-0 position-relative w-100' key={index} >
                                                                <div className='product_item hstack align-items-start'>
                                                                    <div className='product_img'>
                                                                        <img src={c.image ? `${backend_url}${c.image}` : "/assets/images/fruit-apple.png"} alt={c.productName || 'product'} />
                                                                    </div>
                                                                    <div className='product_info'>
                                                                        <div className='product_title_blk'>
                                                                            <h3 className='product_name fs-6 fw-bold mb-0'>{c.productName || 'N/A '}</h3>
                                                                        </div>
                                                                        <ul className='product_title_info list-unstyled mb-0'>
                                                                            <li><span className='card_product_title fw-medium'>Quantity - </span><span className='card_value'>{c.quantity}</span></li>
                                                                            <li><span className='card_product_title fw-medium'>Type - </span><span className='card_value'>{c.productType || 'N/A'}</span></li>
                                                                            <li><span className='card_product_title fw-medium'>Price - </span><span className='card_value'>{c.price ? `$${c.price}` : 'N/A'}</span></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )

                                                    })}
                                                </div>
                                            </div>

                                            <div className='col-md-5'>
                                                {/* <div className='input_section'> */}

                                                {(orderDetailResponse?.data?.scheduledDate && orderDetailResponse?.data?.scheduledTime && role == 'supplier' && orderDetailResponse?.data?.status != 0 &&
                                                    orderDetailResponse?.data?.status != 7) ? (
                                                    <>  <div className='outline_product_card_list'>
                                                        <div className='product_card_header hstack justify-content-between gap-3 pb-0'>
                                                            <h2 className='h5 fw-bold mb-0'>Scheduled Time</h2>
                                                        </div>
                                                        <div className='outline_flex scheduled_time_wrapper'>

                                                            <div className='scheduled_time_mdl_blk'>
                                                                <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-14 fw-medium mb-0'>Date</h3>
                                                                    <span>-</span>
                                                                    <p className='fs-14 fw-medium mb-0 text-end'>{formatDate(orderDetailResponse?.data?.scheduledDate)}</p>
                                                                </div>
                                                                <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-14 fw-medium mb-0'>Expected Time</h3>
                                                                    <span>-</span>
                                                                    <p className='fs-14 fw-medium mb-0 text-end'>{formatTime12Hour(orderDetailResponse?.data?.scheduledTime)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </>
                                                ) :
                                                    (!orderDetailResponse?.data?.scheduledDate && !orderDetailResponse?.data?.scheduledTime && role == 'supplier' && orderDetailResponse?.data?.status != 0 &&
                                                        orderDetailResponse?.data?.status != 7) ?
                                                        <>   <div className='outline_product_card_list'>
                                                            <div className='product_card_header hstack justify-content-between gap-3 pb-0'>
                                                                <h2 className='h5 fw-bold mb-0'>Scheduled Time</h2>
                                                            </div>
                                                            <div className='outline_flex scheduled_time_wrapper'>

                                                                <div className='scheduled_time_mdl_blk'>
                                                                    <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                        <h3 className='fs-14 fw-medium mb-0'>Date</h3>
                                                                        <span>-</span>
                                                                        <p className='fs-14 fw-medium mb-0 text-end'>{formatDate(orderDetailResponse?.data?.scheduledDate)}</p>
                                                                    </div>
                                                                    <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                        <h3 className='fs-14 fw-medium mb-0'>Expected Time</h3>
                                                                        <span>-</span>
                                                                        <p className='fs-14 fw-medium mb-0 text-end'>{formatTime12Hour(orderDetailResponse?.data?.scheduledTime)}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </> :
                                                        (orderDetailResponse?.data?.scheduledDate && orderDetailResponse?.data?.scheduledTime && role == 'supplier' && orderDetailResponse?.data?.status == 0
                                                        ) ?
                                                            <>   <div className='outline_product_card_list'>
                                                                <div className='product_card_header hstack justify-content-between gap-3 pb-0'>
                                                                    <h2 className='h5 fw-bold mb-0'>Scheduled Time</h2>
                                                                </div>
                                                                <div className='outline_flex scheduled_time_wrapper'>

                                                                    <div className='scheduled_time_mdl_blk'>
                                                                        <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                            <h3 className='fs-14 fw-medium mb-0'>Date</h3>
                                                                            <span>-</span>
                                                                            <p className='fs-14 fw-medium mb-0 text-end'>{formatDate(orderDetailResponse?.data?.scheduledDate)}</p>
                                                                        </div>
                                                                        <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                            <h3 className='fs-14 fw-medium mb-0'>Expected Time</h3>
                                                                            <span>-</span>
                                                                            <p className='fs-14 fw-medium mb-0 text-end'>{formatTime12Hour(orderDetailResponse?.data?.scheduledTime)}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </> :
                                                            ((role == 'customer' || role == 'restaurant')) ? (
                                                                <>
                                                                    <div className='outline_flex scheduled_time_wrapper'>
                                                                        <div className='outline_product_card_list'>
                                                                            <div className='product_card_header hstack justify-content-between gap-3 pb-0'>
                                                                                <h2 className='h5 fw-bold mb-0'>Scheduled Time</h2>
                                                                            </div>
                                                                            <div className='scheduled_time_mdl_blk'>
                                                                                <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                                    <h3 className='fs-14 fw-medium mb-0'>Date</h3>
                                                                                    <span>-</span>
                                                                                    <p className='fs-14 fw-medium mb-0 text-end'>{formatDate(orderDetailResponse?.data?.scheduledDate)}</p>
                                                                                </div>
                                                                                <div className='product_info_blk hstack justify-content-between gap-3'>
                                                                                    <h3 className='fs-14 fw-medium mb-0'>Expected Time</h3>
                                                                                    <span>-</span>
                                                                                    <p className='fs-14 fw-medium mb-0 text-end'>{formatTime12Hour(orderDetailResponse?.data?.scheduledTime)}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                // <div className='input_section'>
                                                                <>
                                                                    <div className="input_wrapper">
                                                                        <label>Expected Date</label>
                                                                        <div className="form_field">
                                                                            <input
                                                                                className={`form-control ${validationErrors.date ? 'is-invalid' : ''}`}
                                                                                type="date"
                                                                                min={new Date().toISOString().split("T")[0]}
                                                                                value={selectedDate}
                                                                                onChange={(e) => {
                                                                                    setSelectedDate(e.target.value);
                                                                                    if (validationErrors.date) {
                                                                                        setValidationErrors(prev => ({ ...prev, date: false }));
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="input_wrapper">
                                                                        <label>Expected Time</label>
                                                                        <div className="form_field">
                                                                            <input
                                                                                className={`form-control ${validationErrors.time ? 'is-invalid' : ''}`}
                                                                                type="time"
                                                                                value={selectedTime}
                                                                                onChange={(e) => {
                                                                                    setSelectedTime(e.target.value);
                                                                                    if (validationErrors.time) {
                                                                                        setValidationErrors(prev => ({ ...prev, time: false }));
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {/* </div> */}
                                                                </>
                                                            )}

                                                {/* {(role == 'customer' || role == 'restaurant') && (orderDetailResponse?.data?.status == 4) && <div>
                                                        <label>Add payment type</label>
                                                        <div className='form_field'>
                                                            <select className={`form-select ${validationErrors.paymentType ? 'is-invalid' : ''}`} value={paymentType} onChange={(e) => {
                                                                setPaymentType(e.target.value);
                                                                if (validationErrors.paymentType) {
                                                                    setValidationErrors(prev => ({ ...prev, paymentType: false }));
                                                                }
                                                            }}>
                                                                <option>Select Payment Type</option>
                                                                <option value='Cash'>
                                                                    Cash
                                                                </option>
                                                                <option value='Cheque'>
                                                                    Cheque
                                                                </option>
                                                                <option value='Online'>
                                                                    Online
                                                                </option>
                                                            </select>
                                                        </div>

                                                        <label>Remarks</label>
                                                        <div className='form_field'>
                                                            <input type='text' className={`form-control ${validationErrors.remarks ? 'is-invalid' : ''}`} placeholder='Enter remarks' value={remarks} onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (value.length === 1 && value === ' ') return;
                                                                setRemarks(value);
                                                                if (validationErrors.remarks) {
                                                                    setValidationErrors(prev => ({ ...prev, remarks: false }));
                                                                }
                                                            }} />
                                                        </div>
                                                    </div>
                                                    } */}
                                                <div className='outline_product_card_list mt-4'>
                                                    <div className='product_card_header hstack justify-content-between gap-3'>
                                                        <h2 className='h5 fw-bold mb-0'>Order Details</h2>
                                                    </div>
                                                    <div className=''>
                                                        <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Sub Total</h3>
                                                            <p className='fs-14 fw-medium mb-0'>${orderDetailResponse?.data?.totalPrice}</p>
                                                        </div>

                                                        {!showInput && finalDeliveryCharges == 0 && (orderDetailResponse?.data?.status == 0 || orderDetailResponse?.data?.status == 7) ? (

                                                            <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                                <h3 className='fs-14 fw-medium mb-0'>Delivery Charges</h3>
                                                                <p
                                                                    className="fs-14 fw-medium mb-0"
                                                                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                    onClick={handleClick}
                                                                >
                                                                    Add delivery charges
                                                                </p>
                                                            </div>
                                                        ) : !showInput ? (
                                                            <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                                <h3 className='fs-14 fw-medium mb-0'>Delivery Charges</h3>
                                                                <p
                                                                    className="fs-14 fw-medium mb-0"
                                                                    onClick={(orderDetailResponse?.data?.status == 0 || orderDetailResponse?.data?.status == 7) ? handleClick : undefined}
                                                                    style={{ cursor: 'pointer', textDecoration: 'underline' }} // Allow editing again
                                                                >
                                                                    ${finalDeliveryCharges || orderDetailResponse?.data?.deliveryCharges}
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                                <h3 className='fs-14 fw-medium mb-0'>Delivery Charges</h3>
                                                                <input
                                                                    type="number"
                                                                    value={deliveryCharges}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    autoFocus
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Enter charge"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='product_total_blk hstack justify-content-between gap-3'>
                                                        <h3 className='fs-5 fw-semibold mb-0'>Total</h3>
                                                        <p className='fs-5 fw-semibold mb-0'>${orderDetailResponse?.data?.deliveryCharges ? parseInt(orderDetailResponse?.data?.deliveryCharges) + orderDetailResponse?.data?.totalPrice : finalDeliveryCharges ? parseInt(finalDeliveryCharges) + orderDetailResponse?.data?.totalPrice : orderDetailResponse?.data?.totalPrice}</p>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    {(orderDetailResponse?.data?.status === 0 || orderDetailResponse?.data?.status === 7) && (
                                        ((role === 'supplier' && !orderDetailResponse?.data?.scheduledTime && !orderDetailResponse?.data?.scheduledDate) ||
                                            role === 'customer' ||
                                            role === 'restaurant') && (
                                            <div className='hstack flex-end gap-2 mt-4'>
                                                <button
                                                    className='transparent-btn fs-14 py-2'
                                                    onClick={() => {
                                                        setRejectButtonClicked(prev => !prev);
                                                        handleRejectOrderRequest(orderDetailResponse?.data._id, 2)
                                                    }}
                                                >
                                                    {rejectRequestLoading ? <PulseLoader size={25} color="#000000" /> : 'Reject'}
                                                </button>
                                                <button
                                                    className='primary-btn fs-14 py-2'
                                                    onClick={() => {

                                                        if (role === 'supplier') {
                                                            if (!selectedDate || !selectedTime) {
                                                                setValidationErrors({
                                                                    date: !selectedDate,
                                                                    time: !selectedTime,
                                                                });
                                                                return;
                                                            }
                                                            setAcceptButtonClicked(prev => !prev)
                                                            handleAcceptOrderRequest(orderDetailResponse?.data._id, 1);
                                                        }
                                                        // setAcceptButtonClicked(prev => !prev)
                                                        //handleAcceptOrderRequest(orderDetailResponse?.data._id, 1);
                                                    }}
                                                >
                                                    {acceptRequestLoading ? <PulseLoader size={25} color="#ffffff" /> : 'Accept'}
                                                </button>
                                            </div>

                                        )
                                    )}
                                    {(role == 'customer' || role == 'restaurant') && (orderDetailResponse?.data?.status == 1) &&
                                        <div className='hstack flex-end gap-2 mt-4'>
                                            <button
                                                className='primary-btn fs-14 py-2'
                                                onClick={() => {
                                                    // handleSubmit(orderDetailResponse?.data._id, 4);
                                                    handleSubmitComplete(orderDetailResponse?.data._id, 4);
                                                }}
                                            >
                                                Mark as Complete
                                            </button>
                                        </div>}

                                    {(role == 'supplier') && (orderDetailResponse?.data?.status == 4) &&
                                        <>
                                            {/* <div className='hstack flex-end gap-2 mt-4'>
                                                <button
                                                    className='primary-btn fs-14 py-2'
                                                    onClick={() => setShowStripeForm(true)}
                                                >
                                                    Make Payment
                                                </button>
                                            </div>

                                            {showStripeForm && (
                                                <div
                                                    className='pay_block'
                                                >
                                                    <StripePaymentComponent
                                                        orderId={orderDetailResponse?.data?._id}
                                                        amount={orderDetailResponse?.data?.totalPrice}
                                                        userId={orderDetailResponse?.data?.requesterId}
                                                        onPaymentSuccess={() => {
                                                            handleSubmitComplete(orderDetailResponse?.data?._id, 5);
                                                        }}
                                                        setCompletePayment={setCompletePayment}
                                                        setShowStripeForm={setShowStripeForm}
                                                    />
                                                </div>
                                            )
                                            } */}
                                            {/* 
                                            <div>
                                                <label>Select payment type</label>
                                                <div className='form_field'>
                                                    <select className={`form-select ${validationErrors.paymentType ? 'is-invalid' : ''}`} value={paymentType} onChange={(e) => {
                                                        setPaymentType(e.target.value);
                                                        if (validationErrors.paymentType) {
                                                            setValidationErrors(prev => ({ ...prev, paymentType: false }));
                                                        }
                                                    }}>
                                                        <option>Select Payment Type</option>
                                                        <option value='Cash'>
                                                            Cash
                                                        </option>
                                                        <option value='Cheque'>
                                                            Cheque
                                                        </option>
                                                        <option value='Online'>
                                                            Online
                                                        </option>
                                                    </select>
                                                </div>

                                                <label>Remarks</label>
                                                <div className='form_field'>
                                                    <input type='text' className={`form-control ${validationErrors.remarks ? 'is-invalid' : ''}`} placeholder='Enter remarks' value={remarks} onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length === 1 && value === ' ') return;
                                                        setRemarks(value);
                                                        if (validationErrors.remarks) {
                                                            setValidationErrors(prev => ({ ...prev, remarks: false }));
                                                        }
                                                    }} />
                                                </div>
                                            </div> */}

                                            {/* {!showPaymentTypePopup && (
                                                <div className='hstack flex-end gap-2 mt-4'>
                                                    <button
                                                        className='primary-btn fs-14 py-2'
                                                        onClick={() => setShowPaymentTypePopup(true)}
                                                    >
                                                        Make Payment
                                                    </button>
                                                </div>
                                            )} */}

                                            {/* Make Payment button */}
                                            {!showPaymentTypePopup && (
                                                <div className='hstack flex-end gap-2 mt-4'>
                                                    <button
                                                        className='primary-btn fs-14 py-2'
                                                        onClick={() => setShowPaymentTypePopup(true)}
                                                    >
                                                        Make Payment
                                                    </button>
                                                </div>
                                            )}

                                            {/* Payment type popup */}
                                            {showPaymentTypePopup && (
                                                <div className="pay_block" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                                    <label>Add Payment Type</label>
                                                    <div className='form_field'>
                                                        <select
                                                            className={`form-select ${validationErrors.paymentType ? 'is-invalid' : ''}`}
                                                            value={paymentType}
                                                            onChange={(e) => {
                                                                setPaymentType(e.target.value);
                                                                if (validationErrors.paymentType) {
                                                                    setValidationErrors(prev => ({ ...prev, paymentType: false }));
                                                                }
                                                            }}
                                                        >
                                                            <option>Select Payment Type</option>
                                                            <option value='Cash'>Cash</option>
                                                            <option value='Cheque'>Cheque</option>
                                                            <option value='Online'>Online</option>
                                                        </select>
                                                    </div>

                                                    {/* Conditionally show remarks */}
                                                    {(paymentType === 'Cash' || paymentType === 'Cheque') && (
                                                        <>
                                                            <label>Remarks</label>
                                                            <div className='form_field'>
                                                                <input
                                                                    type='text'
                                                                    className={`form-control ${validationErrors.remarks ? 'is-invalid' : ''}`}
                                                                    placeholder='Enter remarks'
                                                                    value={remarks}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value.length === 1 && value === ' ') return;
                                                                        setRemarks(value);
                                                                        if (validationErrors.remarks) {
                                                                            setValidationErrors(prev => ({ ...prev, remarks: false }));
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* Proceed button */}
                                                    <div className='mt-3'>
                                                        <button
                                                            className='primary-btn fs-14 py-2'
                                                            onClick={() => {
                                                                if (!paymentType || paymentType === 'Select Payment Type') {
                                                                    setValidationErrors(prev => ({ ...prev, paymentType: true }));
                                                                    return;
                                                                }
                                                                if (
                                                                    (paymentType === 'Cash' || paymentType === 'Cheque') &&
                                                                    !remarks.trim()
                                                                ) {
                                                                    setValidationErrors(prev => ({ ...prev, remarks: true }));
                                                                    return;
                                                                }
                                                                if (paymentType === 'Online') {
                                                                    setShowStripeForm(true);
                                                                } else {
                                                                    handleSubmitComplete(orderDetailResponse?.data?._id, 5);
                                                                }
                                                            }}
                                                        >
                                                            Proceed
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                            {showStripeForm && (
                                                <div className='pay_block'>
                                                    <StripePaymentComponent
                                                        orderId={orderDetailResponse?.data?._id}
                                                        amount={orderDetailResponse?.data?.totalPrice}
                                                        userId={orderDetailResponse?.data?.requesterId}
                                                        onPaymentSuccess={() => {
                                                            handleSubmitComplete(orderDetailResponse?.data?._id, 5);
                                                        }}
                                                        setCompletePayment={setCompletePayment}
                                                        setShowStripeForm={setShowStripeForm}
                                                    />
                                                </div>
                                            )}
                                        </>}
                                </div>
                            </div>

                        </div >
                    </section >
                )
            }
        </>
    )
}

export default OrderDetail;